export interface Nameable {
  displayName?: string;
  name?: string;
}

export function componentToName(nameable: Nameable) {
  return nameable.displayName || nameable.name || 'Component';
}
